import { DensityUnits } from "@/libs/units/density";
import { PercentageUnits } from "@/libs/units/percentage";
import type { RenderScenarioExportCols } from "./sizingExportTypes";
import { GenericUnits } from "@/libs/units/generic";
import {
  getHpsOilGravityLabel,
  getHpsWaterGravityLabel
} from "@/utils/hpsLiquidType";

export const renderFluidPropertiesCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => {
  const hpsLiquidType = scenario.wellProperties.value?.hps_liquid_type;

  return [
    {
      section: "Fluid Properties",
      label: getHpsOilGravityLabel(hpsLiquidType),
      targetUnit: DensityUnits.SpecificGravity,
      decimalPlaceOverride: 4,
      value: DensityUnits.API.toStandardUnit(
        scenario.wellProperties.value?.oil_gravity_api
      )
    },
    {
      section: "Fluid Properties",
      label: getHpsWaterGravityLabel(hpsLiquidType),
      targetUnit: DensityUnits.SpecificGravity,
      decimalPlaceOverride: 4,
      value: scenario.wellProperties.value?.water_specific_gravity
    },
    {
      section: "Fluid Properties",
      label: "Gas Gravity",
      targetUnit: DensityUnits.SpecificGravity,
      decimalPlaceOverride: 4,
      value: calcs?.fluidProperties?.gasSpecificGravity?.value
    },
    {
      section: "Fluid Properties",
      label: "H2S",
      targetUnit: PercentageUnits.Percentage,
      value: scenario.wellProperties.value?.h2s_percent
    },
    {
      section: "Fluid Properties",
      label: "CO2",
      targetUnit: PercentageUnits.Percentage,
      value: scenario.wellProperties.value?.co2_percent
    },
    {
      section: "Fluid Properties",
      label: "N2",
      targetUnit: PercentageUnits.Percentage,
      value: scenario.wellProperties.value?.n2_percent
    },
    {
      section: "Fluid Properties",
      label: "Bubble Point Pressure",
      targetUnit: targetUnits.pressureUnit,
      value: calcs.selectedBubblePointPressurePSIA.value
    },
    {
      section: "Fluid Properties",
      label: "Bottomhole Fluid Temperature",
      targetUnit: targetUnits.tempUnit,
      value: scenario.wellProperties.value?.bottomhole_temperature_fahrenheit,
      hidden: !calcs.isScenarioEspShore.value
    },
    {
      section: "Fluid Properties",
      label: "Surface Fluid Temperature",
      targetUnit: targetUnits.tempUnit,
      value: scenario.wellProperties.value?.surface_temperature_fahrenheit,
      hidden: !calcs.isScenarioEspShore.value
    },
    {
      section: "Fluid Properties",
      label: "Oil Volume Factor",
      targetUnit: GenericUnits.BarrelPerStockTankBarrel,
      decimalPlaceOverride: 4,
      value:
        calcs.fluidProperties.fluidPropertiesAtMotor?.value
          ?.oilVolumeFactorBBLSTB
    },
    {
      section: "Fluid Properties",
      label: "Water Volume Factor",
      targetUnit: GenericUnits.BarrelPerStockTankBarrel,
      decimalPlaceOverride: 4,
      value:
        calcs.fluidProperties.fluidPropertiesAtMotor?.value
          ?.waterVolumeFactorBBLSTB
    },
    {
      section: "Fluid Properties",
      label: "Gas Volume Factor",
      targetUnit: GenericUnits.CubicFeetPerStandardCubicFeet,
      decimalPlaceOverride: 4,
      value:
        calcs.fluidProperties.fluidPropertiesAtMotor?.value
          ?.gasVolumeFactorCFSFCF
    }
  ];
};
